import React from 'react'
import { VideoAutoplay, VideoOverlay } from '@mc/video'
import { Modal, ModalClose, ModalContent } from '@mc/design-system'
import { TrackContentType } from '@mc/track-event'
import { VideoPlayer } from 'components/VideoPlayer'

import { EndScreen } from '../EndScreen'

type VideoPlayerModalProps = {
  onClose: () => void
  videoPlayerId?: string
  mediaUuid: string | undefined
  contentId: string
  contentTitle: string
  contentType: TrackContentType
  extraTrackingInfo: Record<string, unknown>
  pageType: string
}

export const VideoPlayerModal = ({
  onClose,
  videoPlayerId,
  mediaUuid,
  contentId,
  contentTitle,
  contentType,
  extraTrackingInfo = {},
  pageType,
}: VideoPlayerModalProps) => (
  <Modal
    backdrop='extra-dark'
    show={!!videoPlayerId || !!mediaUuid}
    onClose={onClose}
  >
    <ModalClose />
    <ModalContent>
      <VideoPlayer
        videoId={videoPlayerId}
        mediaUuid={mediaUuid}
        contentId={contentId}
        contentTitle={contentTitle}
        contentType={contentType}
        extraTrackingParams={extraTrackingInfo}
      >
        <VideoAutoplay />
        <VideoOverlay state={['paused', 'ended']} fade>
          <EndScreen pageType={pageType} />
        </VideoOverlay>
      </VideoPlayer>
    </ModalContent>
  </Modal>
)
